import './burger.scss'
import type { FC, MouseEventHandler } from 'react'

export interface BurgerProps {
    isOpen?: boolean
    onClick: VoidFunction
}

export const Burger: FC<BurgerProps> = props => {
    const { isOpen, onClick } = props

    const onClickHandler: MouseEventHandler<HTMLAnchorElement> = event => {
        event.preventDefault()
        if (onClick) onClick()
    }

    const burgerClass = isOpen ? 'animate' : ''

    return (
        <div className="header-burger">
            <div className="burger-container">
                <a href="#" className="burger-wrapper" data-testid="nav-mobile-burger" onClick={onClickHandler}>
                    <div className={`${burgerClass} burger-menu`} />
                </a>
            </div>
        </div>
    )
}
